import $ from 'jquery';
import {getFullUrlPath} from '../utils/common'; 

export async function canCashOut() {
    try {
        return await $.ajax(getFullUrlPath('EntryIndex/CanCashOut'));
    } catch (e) {
        console.error(e);
    }
}